import { render, staticRenderFns } from "./EduCreateExampaperAside.vue?vue&type=template&id=24ccce0c&scoped=true"
import script from "./EduCreateExampaperAside.vue?vue&type=script&lang=js"
export * from "./EduCreateExampaperAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ccce0c",
  null
  
)

export default component.exports